import { BoxProps, Flex, Icon, Text } from '@chakra-ui/react';
import { FC } from 'react';

import VideoIcon from '@/assets/icons/ic-video.svg';

import { OmnisearchOccurrencePreview } from '@/components/ui/features/lecture/LectureOmnisearch/components/OmnisearchOccurrencePreview';
import { StringParam, useQueryParams } from '@/hooks/useQueryParams';
import { IPosterDocumentOccurrence } from '@/resources/OmnisearchOccurrence';
import { convertSecondsToVideoDuration } from '@/utils/helperFunctions';

interface IOmnisearchVideoOccurrence extends BoxProps {
  context: Array<IPosterDocumentOccurrence>;
  occurrenceIndex: number;
}
export const OmnisearchOccurrenceVideo: FC<IOmnisearchVideoOccurrence> = ({ context, occurrenceIndex, ...rest }) => {
  const { change } = useQueryParams<{ t: string; posterExpanded: string; index: string }>({
    t: StringParam,
    posterExpanded: StringParam,
    index: StringParam,
  });

  const highlightedOccurrence = context.find((c) => c.highlight);

  function goToOccurrence() {
    const timestamp = Math.round(highlightedOccurrence.position.timestamp || 0);

    change({ t: timestamp.toString(), posterExpanded: 'false', index: null }, { method: 'replace', shallow: true });
  }

  const formattedDuration = convertSecondsToVideoDuration(highlightedOccurrence.position.timestamp);

  return (
    <Flex
      w="full"
      _hover={{ cursor: 'pointer' }}
      tabIndex={0}
      role="button"
      alignItems="center"
      onClick={goToOccurrence}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          goToOccurrence();
        }
      }}
      {...rest}
    >
      <Text mr="2" color="black" fontSize="md" fontWeight="bold">
        {formattedDuration}
      </Text>
      <Flex overflow="hidden" color="black" bgColor="white" p="1">
        <Icon mr="1" as={VideoIcon} w="24px" h="24px" />
        <OmnisearchOccurrencePreview context={context} />
      </Flex>
    </Flex>
  );
};
